import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicLayout from "@/components/public/PublicLayout";
import PortalLayout from "@/components/portal/PortalLayout";
import LoginPage from "@/components/portal/LoginPage";

function AppRoutes() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-navy/20 border-t-navy rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-500 font-sans">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/portal/login" element={<LoginPage />} />
      <Route path="/portal/*" element={isAuthenticated ? <PortalLayout /> : <LoginPage />} />
      <Route path="/*" element={<PublicLayout />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
